const workingHours = {
  conflict_on_date: {
    message:
      'Working hours update failed. There are conflicting out-of-office dates. ',
  },
  all_day_conflict: {
    message:
      ' Working hours update failed. There are conflicting out-of-office dates.',
  },
  overlapping_intervals: {
    message:
      'Working hours update failed. There are conflicting out-of-office time slots. ',
  },
  err_date_override_update_failed: {
    message: 'Working hours update failed. Try again later. ',
  },
  err_user_interview_setting_update_failed: {
    message: 'Working hours update failed. Try again later. ',
  },
};

export default workingHours;
